import actionTypes from './publication.actionTypes';
import { createPriceBuckets, createPartnerFilterData } from '../common/sponsorships/filters/filterHelper';
import {getMonths} from '../common/sponsorships/filters/dateFilterHelper';
import * as sponsorshipHelper from '../common/sponsorships/list/sponsorshipHelper';


const initialPublicationsState = {
    isFetching: false,
    pagination: {
        currentPage: 1,
        pageSize: 50,
        recordTotal: 0
    },
    data: [],
    totals: {},
    metrics: [],
    aggregateMetricNames: [],
    aggregateMetricValues: {},
    isExporting: false
};

//Reducers

export function publications(state = initialPublicationsState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_PUBLICATIONS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_PUBLICATIONS_SUCCESS: {
            const pagination = action.pagination;
            let aggregateMetricValues = action.performance_totals ? action.performance_totals: {};

            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                pagination: {
                    pageNumber: pagination.page,
                    pageSize: pagination.per_page,
                    recordTotal: pagination.total
                },
                data: sponsorshipHelper.convertPublications(action.publications),
                totals: {
                    price: action.totals.total_price
                },
                metrics: action.metrics,
                aggregateMetricNames: action.aggregateMetrics,
                aggregateMetricValues: aggregateMetricValues
            });
            break;
        }
        case actionTypes.EXPORT_PUBLICATIONS:
            Object.assign(nextState, state, {
                isExporting: true 
             });
             break;
        case actionTypes.EXPORT_PUBLICATIONS_SUCCESS:
            Object.assign(nextState, state, {
                isExporting: false
             });
             break;
        default:
            nextState = state;
    }
    return nextState;
}

const initialPublicationFiltersState = {
    isFetching: false,
    all: {},
    filterQueryString: '', //Query string that includes the selected filters.
    searchText: ''
};

export function publicationFilters(state = initialPublicationFiltersState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_PUBLICATION_FILTERS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_PUBLICATION_FILTERS_SUCCESS: {
            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                all: {
                    publicationStatuses: action.publication_statuses,
                    accountManagers: action.account_managers,
                    partners: createPartnerFilterData(action.partners),
                    priceBuckets: createPriceBuckets(action.price_buckets),
                    months: getMonths() //Months are calculated client-side.
                },
                filterQueryString: ''
            });
            break;
        }
        case actionTypes.RECEIVE_PUBLICATIONS_SUCCESS:
            Object.assign(nextState, state, {
                filterQueryString: action.filterQueryString,
                searchText: action.searchText,
                sortField: action.sortField,
                sortDirection: action.sortDirection
            });
            break;
        default:
            nextState = state;
    }
    return nextState;
}